<template>
  <div class="fklb-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="tcf-notedit" v-if="!ishavecard">
          <div class="tcf-notedit-spinner">
            未设置数字名片，<router-link to="/work/mpsz" class="a-txt">点击这里立即去设置</router-link>
          </div>
        </div>
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="访客状态">
              <el-select v-model="searchForm.isread" style="width: 120px" clearable>
                <el-option label="未转化" :value="0" />
                <el-option label="已转化" :value="1" />
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="请输入关键字" @keyup.enter.native="Search" />
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content" v-loading="loading">
            <el-table
              :data="tableData"
              stripe
              style="width: 100%;margin-bottom: 20px">
              <el-table-column
                label="头像"
                width="90"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-badge value="新" class="fklb-photo-badge" :hidden="scope.row.isread===1">
                  <el-avatar :size="40" :src="scope.row.imgPath" style="display: block;"></el-avatar>
                  </el-badge>
                </template>
              </el-table-column>
              <el-table-column
                prop="nickname"
                label="昵称"
                width="100"
                show-overflow-tooltip>
              </el-table-column>
<!--              <el-table-column-->
<!--                label="性别"-->
<!--                width="140"-->
<!--                align="center"-->
<!--                show-overflow-tooltip>-->
<!--                <template slot-scope="scope" >-->
<!--                  <i :class="scope.row.sex==0?'el-icon-female':scope.row.sex==1?'el-icon-male':'el-icon-minus'" style="font-size:20px" :style="scope.row.sex==0?'color:#1296db':scope.row.sex==1?'color:#FF00FF':''"></i>-->
<!--                </template>-->
<!--              </el-table-column>-->
              <el-table-column
                prop="phone"
                label="电话"
                width="120"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="viewTime"
                label="访问时间"
                width="160"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                label="访客状态"
                width="100"
                show-overflow-tooltip>
                <template slot-scope="scope" >
                  <el-tag v-if="scope.row.clientid==0" :disable-transitions="true" size="mini" type="danger">未转化</el-tag>
                  <el-tag v-if="scope.row.clientid!=0" :disable-transitions="true" size="mini">已转化</el-tag>
                </template>
              </el-table-column>
              <el-table-column
                label="客户名称"
                width="120"
                show-overflow-tooltip>
                <template slot-scope="scope" >
                  {{scope.row.clientid!=0?scope.row.clientname:'--'}}
                </template>
              </el-table-column>
              <el-table-column
                label="客户状态"
                width="140"
                show-overflow-tooltip>
                <template slot-scope="scope" >
                  <el-tag type="info" v-if="scope.row.clientid!=0&&scope.row.clientmark===0" :disable-transitions="true" size="mini">置入死海</el-tag>
                  <el-tag type="danger" v-if="scope.row.clientid!=0&&scope.row.clientmark===1" :disable-transitions="true" size="mini">回归公海</el-tag>
                  <el-tag type="warning" v-if="scope.row.clientid!=0&&scope.row.clientmark===2&&scope.row.clientgroup!=4" :disable-transitions="true" size="mini">跟进中</el-tag>
                  <el-tag type="success" v-if="scope.row.clientid!=0&&scope.row.clientmark===2&&scope.row.clientgroup==4" :disable-transitions="true" size="mini">已转意向</el-tag>
                  <el-tag v-if="scope.row.clientid!=0&&scope.row.clientmark>=3" :disable-transitions="true" size="mini">已签约</el-tag>
                  <span v-if="scope.row.clientid==0">--</span>
                </template>
              </el-table-column>
              <el-table-column
                label="跟进人"
                min-width="120"
                show-overflow-tooltip>
                <template slot-scope="scope" >
                  <span v-if="scope.row.clientfollow!==null&&scope.row.clientfollow!==undefined&&scope.row.clientfollow!==''">{{scope.row.clientfollow}}</span>
                  <span v-if="scope.row.clientfollow===null||scope.row.clientfollow===undefined||scope.row.clientfollow===''">--</span>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="100"
                align="center"
                fixed="right"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-button icon="el-icon-refresh" :disabled="scope.row.clientid!=0" size="mini" @click="tranClient(scope.row)">转化</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              v-if="total>0"
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="访客转化"
      :visible.sync="editInfoVisible"
      width="40%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="eForm" :model="eForm" :rules="eRules"  label-position="right" label-width="75px" size="small">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="eForm.name" maxlength="5" placeholder="请输入客户姓名"></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="tel">
          <el-input v-model="eForm.tel" maxlength="11" disabled placeholder="请输入11位手机号码" minlength="11"></el-input>
        </el-form-item>
        <el-form-item label="微信" prop="wchat">
          <el-input v-model="eForm.wchat" maxlength="20" placeholder="请输入客户微信号"></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-radio-group v-model="eForm.sex">
            <el-radio :label="2">未知</el-radio>
            <el-radio :label="1">男</el-radio>
            <el-radio :label="0">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="地区" prop="city">
          <el-cascader
            style="width:100%"
            v-model="eForm.city"
            :options="cityoptions"
            placeholder="请选择客户所在地区"
            filterable></el-cascader>
        </el-form-item>
        <el-form-item label="客户等级" prop="level">
          <el-rate v-model="eForm.level" style="padding-top: 6px"></el-rate>
        </el-form-item>
        <el-form-item label="线下门店" prop="shop">
          <el-input v-model="eForm.shop" maxlength="100" placeholder="请输入线下门店地址"></el-input>
        </el-form-item>
        <el-form-item label="门店面积" prop="area" style="width: 300px;">
          <el-input v-model="eForm.area" type="number" placeholder="请输入门店面积">
            <template slot="append">m²</template>
          </el-input>
        </el-form-item>
        <el-form-item label="客户来源" prop="source">
          <el-select v-model="eForm.source" placeholder="请选择客户来源">
            <el-option label="第三方平台" :value="1"></el-option>
            <el-option label="招商会" :value="2"></el-option>
            <el-option label="异业介绍" :value="3"></el-option>
            <el-option label="地推" :value="4"></el-option>
            <el-option label="商场推荐" :value="5"></el-option>
            <el-option label="数字名片" :value="6"></el-option>
            <el-option label="其他" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="eForm.remark" maxlength="200" placeholder="请输入备注内容"></el-input>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="editloading" @click="submitForm('eForm')">立即提交</el-button>
          <el-button @click="editInfoVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { selectCardViewList, selectUseridCallingCard } from '@/api/zsxcx'
import { validatePhoneNumber } from '@/utils/validate'
import { getCity } from '@/utils/city'
import { addClient } from '@/api/work'
export default {
  name: 'fklb',
  computed: {
    user: getUser
  },
  data() {
    const validateTel = (rule, value, callback) => {
      if (!validatePhoneNumber(value)) {
        callback(new Error('请输入正确的联系电话'))
      } else {
        callback()
      }
    }
    return {
      ishavecard: false,
      searchForm: {
        search: '',
        isread: null
      },
      loading: false,
      tableData: [],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      editInfoVisible: false,
      cityoptions: getCity(),
      eForm: {
        name: '',
        tel: '',
        sex: 2,
        wchat: '',
        city: [],
        groupid: null,
        remark: '',
        shop: '',
        area: null,
        source: 6,
        level: 1
      },
      eRules: {
        name: [{ required: true, message: '请输入客户姓名', trigger: 'blur' }],
        tel: [{ required: true, trigger: 'blur', validator: validateTel }],
        sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
        city: [{ type: 'array', required: true, message: '请选择客户所在地区', trigger: 'blur' }],
        area: [{ pattern: /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/, message: '请输入正确的面积', trigger: 'blur', required: false }],
        source: [{ required: true, message: '请选择客户来源', trigger: 'change' }]
      },
      editloading: false
    }
  },
  created() {
    this.getCardInfo()
  },
  methods: {
    getCardInfo() {
      selectUseridCallingCard({ userid: this.user.dUserid }).then(response => {
        if (response.data !== null && response.data !== undefined) {
          this.ishavecard = true
          this.getData()
        }
      })
    },
    tranClient(row) {
      this.eForm = {
        name: '',
        tel: row.phone,
        sex: 2,
        wchat: '',
        city: [],
        groupid: null,
        remark: '',
        shop: '',
        area: null,
        source: 6,
        level: 1
      }
      this.editInfoVisible = true
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.editloading) {
            this.editloading = true
            const data = {
              userid: this.user.dUserid,
              realname: this.eForm.name,
              tel: this.eForm.tel,
              weixin: this.eForm.wchat,
              province: this.eForm.city[0],
              city: this.eForm.city[1],
              county: this.eForm.city[2],
              remark: this.eForm.remark,
              clientid: 0,
              sex: this.eForm.sex,
              shop: this.eForm.shop,
              area: this.eForm.area,
              source: this.eForm.source,
              level: this.eForm.level
            }
            addClient(data).then(response => {
              this.$message({
                message: '访客已转化为客户',
                type: 'success'
              })
              this.editInfoVisible = false
              this.editloading = false
              this.getData()
            }).catch(() => {
              this.editloading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    Search() {
      this.currentPage = 1
      this.getData()
    },
    getData() {
      this.loading = true
      const data = {
        userid: this.user.dUserid,
        page: this.currentPage,
        limit: this.pageSize,
        groupid: this.user.dGroupid,
        search: this.searchForm.search,
        isread: this.searchForm.isread
      }
      selectCardViewList(data).then(response => {
        this.tableData = response.data
        this.total = response.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    }
  }
}
</script>

<style scoped>

</style>
